import CustomTooltip from '../../../../Components/Common/CustomTooltip';
import { FundHoldingItem } from '../../../../types/fundsummary.type';
import './TopHolding.css';

export interface TopHoldingProps {
  holdings?: FundHoldingItem[];
}

const TopHolding = ({ holdings = [] }: TopHoldingProps): JSX.Element => {
  const maxWeight = holdings.reduce((m, h) => Math.max(m, h.weight), 0);

  return (
    <section className="top-holding">
      <div className="top-holding__subheader">
        <span className="top-holding__subheader-title">Top 10 Holdings</span>
        <span className="top-holding__subheader-meta">% of TNA</span>
      </div>

      <div className="top-holding__list">
        {holdings.map((holding, index) => (
          <div className="top-holding__item" key={index}>
            <div className="top-holding__labels">
              <div className="top-holding__name-wrap">
                <CustomTooltip title={holding.holdingName} placement="auto-end">
                  <span className="top-holding__name">
                    {holding.holdingName}
                  </span>
                </CustomTooltip>
              </div>

              <span className="top-holding__weight">
                {holding.weight.toFixed(2)}%
              </span>
            </div>
            <div className="top-holding__bar">
              <span
                className="top-holding__bar-fill"
                style={{
                  width: `${
                    maxWeight > 0 ? (holding.weight / maxWeight) * 100 : 0
                  }%`,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TopHolding;
